// Файл: frontend/src/context/AuthContext.js (ФИНАЛЬНАЯ ВЕРСИЯ)

import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  // --- НАЧАЛЬНОЕ СОСТОЯНИЕ ТЕПЕРЬ БОЛЕЕ УМНОЕ ---
  const [user, setUser] = useState(() => {
    // Мы считаем пользователя залогиненным, только если есть и токен, и данные
    const savedToken = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    return savedToken && savedUser ? JSON.parse(savedUser) : null;
  });

  const [token, setToken] = useState(() => localStorage.getItem('token') || null);

  // Этот useEffect будет следить за изменениями и синхронизировать localStorage
  useEffect(() => {
    if (token && user) {
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('token', token);
    } else {
      // Если чего-то одного нет, очищаем все
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    }
  }, [user, token]);

  const login = (userData, userToken) => {
    setUser(userData);
    setToken(userToken);
  };

  const logout = () => {
    setUser(null);
    setToken(null);
  };

  const value = {
    user,
    token,
    login,
    logout,
    isAuthenticated: !!user && !!token // <-- Проверка стала строже
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};